// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ui-calendar-controls{align-items:center;display:flex;height:2.5rem;justify-content:space-between}.ui-calendar-controls__month-and-year{font-size:.9375rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
